import styled, { css } from 'styled-components';

import { DROPDOWN_ITEM } from 'consts';
import { Colors } from 'environment';
import { Typography } from 'components/UI/Typography';
import { Checkbox } from 'components/UI/Interactables/Checkbox/Checkbox.style';
import { Container as IconContainer } from 'components/UI/Icons/Icon.style';
import { Disabled } from 'helpers/cssGenerators';
interface ContainerProps extends Disabled {
	button?: boolean;
}
interface TextProps {
	active: boolean;
	textColor?: string;
}

export const Text = styled(Typography.Paragraph)<TextProps>`
	color: ${({ active }) => (active ? Colors.primary.normal : Colors.text.main)};
	user-select: none;
	${({ textColor }) => {
		if (textColor) {
			return css`
				color: ${textColor};
			`;
		}
	}}
`;

export const TooltipWrapper = styled.div`
	width: 100%;
`;

export const Container = styled.div<ContainerProps>`
	${({ disabled, button }) => css`
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;

		/* THIS NEEDS TO BE REVISED */
		/* min-height: ${button
			? DROPDOWN_ITEM.button.minHeight + 'px'
			: DROPDOWN_ITEM.regular.minHeight + 'px'}; */

		min-height: 3rem;
		padding: 0.4rem 0.8rem;
		cursor: pointer;

		${Checkbox} {
			transition: all 0s;
		}

		${!disabled &&
		css`
			:hover {
				background-color: ${Colors.primary.normal};

				${Text}, * {
					color: ${Colors.white};
				}

				${Checkbox} {
					border-color: ${Colors.white};
					background: ${Colors.primary.normal};
				}

				.checked {
					${Checkbox} {
						border-color: ${Colors.white};
						background: ${Colors.white};

						${IconContainer} * {
							color: ${Colors.primary.normal};
						}
					}
				}
			}
		`};

		${disabled &&
		css`
			pointer-events: none;

			${Text}, * {
				color: ${Colors.text.disabled};
			}

			${Checkbox} {
				border-color: ${Colors.text.disabled};
				background: ${Colors.white};
			}

			.checked {
				${Checkbox} {
					border-color: ${Colors.primary.disabled};
					background: ${Colors.primary.disabled};

					${IconContainer} * {
						color: ${Colors.white};
					}
				}
			}
		`}
	`}
`;
